import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { observer } from 'mobx-react'
import queryString from 'query-string'
import Survey from '@components/Survey'
import Loader from '@ui/Loader'
import useStores from '@stores/useStores'
import { callFingerPrinting } from './utils'

const Surveys = ({ match, location, history }) => {
  const { surveyState, user, authentication } = useStores()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      const { id } = match.params || {}
      const params = queryString.parse(location.search) || {}

      window.onbeforeunload = onUnload
      authentication.cleanStorage()
      surveyState.setParams(id, params)
      surveyState.org_id = params.org
      if (params.question_id && params.action) {
        surveyState.setPreAnswer(params.question_id, params.action)
      }
      user.setSignature(params.signature)
      await Promise.all([surveyState.getSurvey(), surveyState.getLanguages()])
      callFingerPrinting({
        isSelfAssessment: surveyState.isSelfAssessment,
        signature: params.signature,
        request_id: params.req_id
      })
      if (surveyState.error) {
        if (!surveyState.isRedirecting) history.push('/error')
      } else {
        surveyState.startSurvey()
        setLoading(false)
      }
    }

    fetchData()

    return () => {
      window.onbeforeunload = null
    }
  }, [])

  const onUnload = () => alert('Reload site', 'Changes you made may not be saved.')

  return loading ? <Loader /> : <Survey />
}

export default withRouter(observer(Surveys))
